"use strict"

import {observable, action} from "mobx"

class DuplicityPersonModalStore {
	@observable isOpen = false
	@observable patientData = undefined
	form = undefined

	@action open(form) {
		this.isOpen = true
		this.form = form
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new DuplicityPersonModalStore()
export default singleton
